import { useEffect, useState } from "react";

export const useScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const hasScrollbar =
      document.documentElement.scrollHeight > window.innerHeight;
    setIsVisible(hasScrollbar && window.scrollY > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return {
    isVisible,
    scrollToTop,
    scrollViewRef: null,
    handleScroll: () => {},
  };
};
